<template>
  <div class="loginPage">
    <v-row dense no-gutters class="auth-row">
      <v-col cols="12" sm="12" md="6" class="custom-height">
        <div class="auth-light-version mt-6">
          <div class="logo mb-12">
            <v-img :width="logoWidth" :height="logoHeight" :src="logoSrc"></v-img>
          </div>

          <h3 class="mb-6">Create New Account</h3>

          <v-form class="deposit-form password-field">
            <div class="form-details pt-0 pb-10">
              <template v-if="registerInfo.otpSent === 0">
                <fieldset v-if="registerInfo.owner_type == 2">
                  <legend>Company Name</legend>
                  <v-text-field placeholder="Enter Company Name" type="text" v-model="registerInfo.fname" single-line
                    solo hide-details class="custom-select" />
                </fieldset>

                <template v-else>
                  <fieldset>
                    <legend>First Name</legend>
                    <v-text-field placeholder="Write First Name" type="text" v-model="registerInfo.fname" single-line
                      solo hide-details="auto" class="custom-select" :counter="12" maxlength="12" :rules="[
                        v => !!v || 'First Name is required',
                        v => (v || '').length <= 12 || 'Maximum 12 characters allowed',
                        v => /^[A-Za-z\s]+$/.test(v || '') || 'Only letters allowed',
                        v => !/(https?:\/\/|www\.|\.(com|net|org|io)\b)/i.test(v || '') || 'Links are not allowed'
                      ]" />
                  </fieldset>

                  <fieldset>
                    <legend>Last Name</legend>
                    <v-text-field placeholder="Write Last Name" type="text" v-model="registerInfo.lname" single-line
                      solo hide-details="auto" class="custom-select" :counter="12" maxlength="12" :rules="[
                        v => !!v || 'Last Name is required',
                        v => (v || '').length <= 12 || 'Maximum 12 characters allowed',
                        v => /^[A-Za-z\s]+$/.test(v || '') || 'Only letters allowed',
                        v => !/(https?:\/\/|www\.|\.(com|net|org|io)\b)/i.test(v || '') || 'Links are not allowed'
                      ]" />
                  </fieldset>
                </template>

                <fieldset>
                  <legend>Select Country</legend>
                  <v-select :items="countries" item-text="name" item-value="id" @change="countryCng"
                    placeholder="Select Country" v-model="registerInfo.country" solo hide-details
                    class="custom-select reg-page" />
                </fieldset>

                <fieldset>
                  <legend>Email</legend>
                  <v-text-field placeholder="Write your email address" type="email" v-model="registerInfo.email"
                    single-line solo hide-details="auto" class="custom-select" :counter="100" maxlength="100" :rules="[
                      v => !!v || 'Email is required',
                      v => (v || '').length <= 100 || 'Maximum 100 characters allowed',
                      v => /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(v || '') || 'Invalid email format'
                    ]" />
                </fieldset>

                <div v-if="inv_referred_by">
                  <fieldset>
                    <legend>
                      Copy Ratio
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-on="on" v-bind="attrs" style="cursor: pointer;" class="tooltip-custom">
                            mdi-help-circle-outline
                          </v-icon>
                        </template>
                        <span>Trades will be copied according to the selected ratio.</span>
                      </v-tooltip>
                    </legend>

                    <v-select ref="accountTypeSelect" v-model="registerInfo.multiply_by" solo :items="copyTradeAsRatio"
                      item-value="id" item-text="ratio_type_display" append-icon="mdi-chevron-down"
                      label="Select Copy Ratio" class="custom-select" single-line hide-details="auto" />
                  </fieldset>
                </div>

                <fieldset>
                  <legend>Password</legend>
                  <v-text-field placeholder="Write Password Here" :type="passwordVisible ? 'text' : 'password'"
                    :append-icon="passwordVisible ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="passwordVisible = !passwordVisible" v-model="registerInfo.password" single-line solo
                    hide-details counter class="custom-select" />

                  <div v-if="passwordField" class="mt-4">
                    <span v-for="(condition, index) in passwordConditions" :key="index" class="condition-items">
                      <v-icon small :class="condition.met ? 'text--green' : 'text--ash'">
                        mdi-check
                      </v-icon>
                      <span class="text--dark">{{ condition.text }}</span>
                    </span>
                  </div>
                </fieldset>

                <fieldset class="margin-custom">
                  <legend>Confirm Password</legend>
                  <v-text-field placeholder="Write Password Again" :type="confirmPasswordVisible ? 'text' : 'password'"
                    :append-icon="confirmPasswordVisible ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="confirmPasswordVisible = !confirmPasswordVisible"
                    v-model="registerInfo.confirmPassword" single-line solo hide-details counter
                    class="custom-select" />
                </fieldset>

                <v-radio-group v-model="getOtpIn" row class="mt-5 mb-8" hide-details v-if="otp_via == 1">
                  <v-radio label="OTP via email" value="emailOtp" color="teal" class="custom-radio-buttons"
                    :ripple="false" />
                  <v-radio label="OTP via phone" value="phoneOtp" color="teal" class="custom-radio-buttons"
                    :ripple="false" />
                </v-radio-group>

                <fieldset class="mb-5 mt-5 agree" v-if="getOtpIn === 'phoneOtp' && otp_via == 1">
                  <legend>Phone No <small>(With country Code *)</small></legend>
                  <v-text-field placeholder="Write phone number" type="text" v-model="registerInfo.otpPhoneNo"
                    single-line solo hide-details counter class="custom-select" />
                </fieldset>

                <div class="mb-5 mt-5 agree">
                  <input type="checkbox" v-model="checkbox" class="custom-checkbox" />
                  I Agree With Your
                  <a target="_blank" :href="termsAndConditionLink"> Terms & Conditions</a>
                </div>

                <v-btn class="ma-0 text-capitalize btn-account" color="#039de9" tile block elevation="0"
                  @click.prevent="handleInitialSendOTP" :loading="loading" :disabled="loading ||
                    !isEmailValid ||
                    !isOtpSendvalid ||
                    !isPasswordFieldsValid ||
                    !arePasswordsMatching ||
                    !checkbox ||
                    !fnameCheck ||
                    !registerInfo.country ||
                    !invCheck ||
                    maxOtpReached
                    ">
                  Next
                </v-btn>

                <p v-if="maxOtpReached" class="otp-limit-text mt-3">
                  OTP request limit reached. Maximum 3 attempts allowed.
                </p>
              </template>

              <template v-else>
                <div class="pt-5">
                  <fieldset>
                    <legend>OTP</legend>
                    <v-text-field placeholder="Enter OTP" single-line solo hide-details :value="registerInfo.otp"
                      @input="(value) => REGISTER_INFO({ field: 'otp', value })" class="custom-select" />
                  </fieldset>

                  <div class="otp-meta-box">
                    <p class="mb-1">
                      Last sent via:
                      <strong class="text--green">{{ lastSentMethodLabel }}</strong>
                    </p>
                    <p class="mb-1">
                      Current selected method:
                      <strong>{{ currentMethodLabel }}</strong>
                    </p>
                    <p class="mb-0" v-if="otpCountdown > 0">
                      You can request again in
                      <strong class="text--green">{{ formattedOtpCountdown }}</strong>
                    </p>
                  </div>

                  <p class="text--ash otp-action-line" v-if="otpCountdown <= 0">
                    Didn't Receive OTP?
                    <a class="text--green" href="#" @click.prevent="handleResendOtp"
                      :class="{ 'disabled-link': !canResend }">
                      Re-Send
                    </a>
                    Or
                    <a class="text--green" href="#" @click.prevent="handleTryAnotherMethod"
                      :class="{ 'disabled-link': !canTryAnotherMethod }">
                      Try Another Method
                    </a>
                  </p>

                  <fieldset v-if="showAlternateEmailField">
                    <legend>Email</legend>
                    <v-text-field placeholder="Write your email address" type="email" v-model="registerInfo.email"
                      single-line solo hide-details="auto" class="custom-select" :counter="100" maxlength="100" :rules="[
                        v => !!v || 'Email is required',
                        v => (v || '').length <= 100 || 'Maximum 100 characters allowed',
                        v => /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(v || '') || 'Invalid email format'
                      ]" />
                  </fieldset>

                  <fieldset class="mb-5 mt-5 agree" v-if="showAlternatePhoneField">
                    <legend>Phone No <small>(With country Code *)</small></legend>
                    <v-text-field placeholder="Write phone number" type="text" v-model="registerInfo.otpPhoneNo"
                      single-line solo hide-details counter class="custom-select" />
                  </fieldset>

                  <div class="text-center" v-if="otpAgain">
                    <v-btn :disabled="loading || !canOtpAction" class="text-capitalize btn-account mb-5 w-50 greenMain"
                      @click.prevent="handleAlternateMethodSend">
                      Send
                    </v-btn>
                  </div>

                  <p v-if="maxOtpReached" class="otp-limit-text text-center mt-2">
                    OTP request limit reached. Maximum 3 attempts allowed.
                  </p>

                  <div class="px-0 pb-0">
                    <v-row no-gutters>
                      <v-col cols="4">
                        <v-btn class="ma-0 text-capitalize btn-account" color="greenMain" tile block elevation="0"
                          @click.prevent="previous">
                          Previous
                        </v-btn>
                      </v-col>

                      <v-col cols="8" class="pl-2">
                        <v-btn class="ma-0 text-capitalize btn-account" color="greenMain" tile block elevation="0"
                          @click.prevent="handleRegister" :loading="loadingCreate"
                          :disabled="!allConditionsMet || loadingCreate">
                          Create Account
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </template>

              <div class="another-link mt-6">
                <p>
                  Already have an account?
                  <router-link to="/">Log in</router-link>
                </p>
              </div>
            </div>
          </v-form>
        </div>
      </v-col>

      <v-col cols="12" sm="12" md="6" class="image-col">
        <div class="image-content">
          <h3 class="mb-2">High Risk Investment Warning:</h3>
          <p>
            Trading Leveraged Products such as Forex and Derivatives may not be suitable
            for all investors as they carry a high degree of risk to your capital.
            Please ensure that you fully understand the risks involved, taking into
            account your investments objectives and level of experience, before trading,
            and if necessary, seek independent advice.
          </p>
          <social-icons :info="genInfo"></social-icons>
        </div>

        <div class="image-container">
          <v-img src="@/assets/auth.png" class="zoom-animate-full image-full"></v-img>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import LanguageMenu from "@/components/TopBar/LanguageMenu.vue";
import { PUBLIC_LOGIN__ACTIONS } from "@/store/action-types";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import SocialIcons from "./SocialIcons.vue";

export default {
  components: { LanguageMenu, SocialIcons },

  data() {
    return {
      genInfo: {},
      checkbox: false,
      loading: false,
      getOtpIn: "emailOtp",
      otpAgain: false,
      loadingCreate: false,
      passwordVisible: false,
      confirmPasswordVisible: false,
      inv_referred_by: null,

      otpRequestCount: 0,
      maxOtpRequestLimit: 3,
      otpCountdown: 0,
      otpTimer: null,
      lastSentOtpMethod: null,

      copyTradeAsRatio: [
        { id: 0, ratio_type_display: "Proportional to equity" },
        { id: 1, ratio_type_display: "1X" },
        { id: 2, ratio_type_display: "2X" },
        { id: 3, ratio_type_display: "3X" },
        { id: 4, ratio_type_display: "4X" },
        { id: 5, ratio_type_display: "5X" },
      ],
      selectedRatio: 0,
      e1: 1,
      fields: [
        {
          name: "fname",
          legend: "First Name",
          placeholder: "John",
          type: "text",
        },
        {
          name: "lname",
          legend: "Last Name",
          placeholder: "Doe",
          type: "text",
        },
        {
          name: "country",
          legend: "Select Country",
          placeholder: "Select Country",
          type: "select",
        },
        {
          name: "email",
          legend: "Email",
          placeholder: "Write your email address",
          type: "email",
        },
        {
          name: "password",
          legend: "Password",
          placeholder: "Enter Here",
          type: "password",
          show: false,
          counter: true,
        },
        {
          name: "confirmPassword",
          legend: "Confirm Password",
          placeholder: "Write Password Again",
          type: "password",
          show: false,
          counter: true,
        },
      ],
    };
  },

  computed: {
    ...mapState("register", ["registerInfo", "registrationError", "otp_via"]),
    ...mapGetters("register", ["isOtpSent", "isOtpVerified", "isRegistered"]),
    ...mapState("publicinfo", ["info", "countries", "termsAndConditionLink"]),

    isEmailValid() {
      const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
      return emailRegex.test(this.registerInfo.email || "");
    },

    isOtpSendvalid() {
      if (this.getOtpIn === "phoneOtp") {
        return !!this.registerInfo.otpPhoneNo && this.registerInfo.otpPhoneNo.trim().length > 0;
      }
      return true;
    },

    isPasswordFieldsValid() {
      return (
        this.registerInfo.password &&
        this.registerInfo.confirmPassword &&
        this.registerInfo.password.length > 0 &&
        this.registerInfo.confirmPassword.length > 0 &&
        this.passwordConditions.every((condition) => condition.met)
      );
    },

    arePasswordsMatching() {
      return (
        this.registerInfo.password === this.registerInfo.confirmPassword &&
        this.registerInfo.password !== "" &&
        this.registerInfo.confirmPassword !== ""
      );
    },

    fnameCheck() {
      return (
        this.registerInfo.fname &&
        this.registerInfo.fname.trim().length > 0 &&
        this.registerInfo.fname.length <= 12
      );
    },

    invCheck() {
      if (this.inv_referred_by) {
        return this.registerInfo.multiply_by !== null && this.registerInfo.multiply_by !== "";
      }
      return true;
    },

    passwordConditions() {
      const password = this.registerInfo.password || "";
      return [
        { met: password.length >= 8, text: "8 Characters" },
        { met: /[a-z]/.test(password), text: "1 Lowercase" },
        { met: /[A-Z]/.test(password), text: "1 Uppercase" },
        { met: /\d/.test(password), text: "1 Digit" },
        { met: /[@$!%*?&]/.test(password), text: "1 Special Character" },
      ];
    },

    allConditionsMet() {
      return (
        this.isPasswordFieldsValid &&
        this.arePasswordsMatching &&
        this.registerInfo.otp &&
        this.registerInfo.otp.length > 0
      );
    },

    passwordField() {
      return this.fields.find((field) => field.name === "password");
    },

    logoSrc() {
      return this.$vuetify.theme.light ? this.info?.logo_url : this.info?.logo_url_dark;
    },

    logoWidth() {
      return this.info?.logo_width || "100%";
    },

    logoHeight() {
      return this.info?.logo_height || "100%";
    },

    formattedOtpCountdown() {
      const minutes = Math.floor(this.otpCountdown / 60);
      const seconds = this.otpCountdown % 60;
      return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
    },

    maxOtpReached() {
      return this.otpRequestCount >= this.maxOtpRequestLimit;
    },

    canOtpAction() {
      return !this.loading && !this.maxOtpReached && this.otpCountdown === 0;
    },

    canResend() {
      return this.registerInfo.otpSent === 1 && this.canOtpAction && !!this.lastSentOtpMethod;
    },

    canTryAnotherMethod() {
      if (this.otp_via != 1) return false;
      return this.registerInfo.otpSent === 1 && this.canOtpAction && !!this.lastSentOtpMethod;
    },

    currentMethodLabel() {
      return this.getOtpIn === "phoneOtp" ? "SMS" : "Email";
    },

    lastSentMethodLabel() {
      if (this.lastSentOtpMethod === "phoneOtp") return "SMS";
      if (this.lastSentOtpMethod === "emailOtp") return "Email";
      return "-";
    },

    showAlternateEmailField() {
      return this.otpAgain && this.getOtpIn === "emailOtp";
    },

    showAlternatePhoneField() {
      return this.otpAgain && this.getOtpIn === "phoneOtp" && this.otp_via == 1;
    },
  },

  methods: {
    ...mapMutations("register", {
      REGISTER_INFO: "SET_REGISTER_INFO",
    }),

    ...mapActions("register", [
      "sendOTP",
      "isSmsOtp",
      "previousStep",
      "verifyOTP",
      "register",
      "initializeReferral",
    ]),

    ...mapActions("publicinfo", [
      PUBLIC_LOGIN__ACTIONS.LOGINPAGEINFO,
      PUBLIC_LOGIN__ACTIONS.TERMSANDCONDITIONLINK,
      PUBLIC_LOGIN__ACTIONS.COUNTRIES,
    ]),

    startOtpTimer() {
      this.clearOtpTimer();
      this.otpCountdown =  0;

      this.otpTimer = setInterval(() => {
        if (this.otpCountdown > 0) {
          this.otpCountdown--;
        } else {
          this.clearOtpTimer();
        }
      }, 1000);
    },

    clearOtpTimer() {
      if (this.otpTimer) {
        clearInterval(this.otpTimer);
        this.otpTimer = null;
      }
    },

    countryCng() {
      const selectedCountry = this.countries.find(
        (country) => country.id === this.registerInfo.country
      );

      if (selectedCountry && selectedCountry.isd_code) {
        const existingNumber = (this.registerInfo.otpPhoneNo || "").replace(/^\+\d+/, "");
        this.registerInfo.otpPhoneNo = `+${selectedCountry.isd_code}${existingNumber}`;
      }
    },

    async sendOtpByMethod(method) {
      if (this.maxOtpReached || this.otpCountdown > 0) return;

      try {
        this.loading = true;

        await this.sendOTP({
          otp_via: method,
        });

        this.lastSentOtpMethod = method;
        this.getOtpIn = method;
        this.otpRequestCount++;
        this.startOtpTimer();
        this.otpAgain = false;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async handleInitialSendOTP() {
      await this.sendOtpByMethod(this.getOtpIn);
    },

    async handleResendOtp() {
      if (!this.lastSentOtpMethod) return;
      await this.sendOtpByMethod(this.lastSentOtpMethod);
    },

    handleTryAnotherMethod() {
      if (!this.canTryAnotherMethod) return;

      const nextMethod =
        this.lastSentOtpMethod === "phoneOtp" ? "emailOtp" : "phoneOtp";

      this.getOtpIn = nextMethod;
      this.otpAgain = true;
    },

    async handleAlternateMethodSend() {
      await this.sendOtpByMethod(this.getOtpIn);
    },

    async previous() {
      try {
        await this.previousStep();
        this.otpAgain = false;
        this.clearOtpTimer();
        this.otpCountdown = 0;
      } catch (error) {
        console.log(error);
      }
    },

    async handleRegister() {
      if (!this.allConditionsMet) return;

      try {
        this.loadingCreate = true;

        if(this.getOtpIn == "emailOtp"){
          this.registerInfo.otpPhoneNo = "";
        }
        
        await this.verifyOTP();

        if (this.isOtpVerified) {
          await this.register();

          if (window.fbq) {
            window.fbq("track", "CompleteRegistration", {
              fn: this.registerInfo.fname,
              ln: this.registerInfo.lname,
            });
          }

          this.$router.push("/login");
        }
      } catch (error) {
        console.error("Error during registration:", error);
      } finally {
        this.loadingCreate = false;
      }
    },
  },

  async mounted() {
    await this[PUBLIC_LOGIN__ACTIONS.LOGINPAGEINFO]();
    await this[PUBLIC_LOGIN__ACTIONS.TERMSANDCONDITIONLINK]();
    await this[PUBLIC_LOGIN__ACTIONS.COUNTRIES]();
    this.initializeReferral();

    this.genInfo = this.info || {};

    if (!window.fbq) {
      !(function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = "2.0";
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");

      window.fbq("init", "1601047264632923");
    }

    window.fbq("track", "PageView");
  },

  async created() {
    const urlParams = new URLSearchParams(window.location.search);
    this.inv_referred_by = urlParams.get("inv_referred_by");
    await this.isSmsOtp();
  },

  beforeDestroy() {
    this.clearOtpTimer();
  },
};
</script>

<style>
.text--dark {
  color: #131c29 !important;
  margin: 10px;
}

.reg-page .v-list .v-list-item--active {
  background-color: #F1F7FB !important;
}

.reg-page .v-list .v-select-list {
  background-color: #1B1D81 !important;
}

.tooltip-custom {
  position: relative;
  top: 0;
  left: 3px;
  font-size: 15px;
  color: #ffffffa1;
}

.margin-custom {
  margin-top: 75px;
}

.condition-items {
  overflow: visible;
  font-size: 13px;
  align-items: center;
  color: #708aa7;
}

.agree {
  color: #131c29;
  font-size: 13px;
}

.agree a {
  color: #039DE9;
}

.custom-checkbox {
  appearance: none;
  width: 15px;
  height: 15px;
  outline: none;
  cursor: pointer;
  border: 1px solid #3f546b;
  border-radius: 2px;
  background: #ffffff00;
  transition: background 0.3s, border-color 0.3s;
  margin-right: 8px;
  position: relative;
  top: 2px;
}

.custom-checkbox:checked {
  background: #131c29;
  border-color: #039DE9;
}

.custom-checkbox:checked::after {
  content: "✔";
  position: absolute;
  top: -9px;
  left: 2px;
  font-size: 20px;
}

.custom-checkbox:hover {
  border-color: #039DE9 !important;
}

.custom-checkbox {
  border: 1px solid #039DE9;
}

.custom-checkbox:checked {
  background: #ffffff00;
  border-color: #039DE9;
}

.custom-checkbox:checked::after {
  color: #039DE9;
}

.custom-checkbox:hover {
  border-color: #039DE9;
}

.v-select-list {
  background: #f1f7fb;
}

.error-message {
  color: #f44336;
  font-size: 12px;
  text-align: center;
}

.custom-radio-buttons .mdi-radiobox-blank {
  color: #039ce9b4 !important;
}

.custom-radio-buttons .v-input--selection-controls__input i {
  font-size: 14px;
}

.custom-radio-buttons .v-label {
  color: #292929dc;
  font-weight: 500;
  font-size: 14px;
}

.custom-radio-buttons {
  margin-right: 16px;
  margin-left: -6px;
}

.text-center {
  text-align: center;
}

.w-50 {
  max-width: 200px !important;
  padding: 10px 15px;
  border: none;
  color: #fff;
  cursor: pointer;
}

.otp-meta-box {
  border: 1px solid #e4edf5;
  border-radius: 6px;
  padding: 12px 14px;
  margin-top: 4px;
  margin-bottom: 16px;
}

.otp-action-line {
  margin-bottom: 14px;
}

.disabled-link {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
  margin: 0 4px;
}

.otp-limit-text {
  color: #d32f2f;
  font-size: 13px;
  font-weight: 600;
}
</style>